var AWS = require('../core');

// pull in CloudFront signer
require('../cloudfront/signer');

AWS.util.update(AWS.CloudFront.prototype, {

  setupRequestListeners: function setupRequestListeners(request) {
    request.addListener('extractData', AWS.util.hoistPayloadMember);
  }

});



//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/lib/services/cloudfront.js
// module id = 773
// module chunks = 0